import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LiffService } from '../liff.service';
import { AuthService } from '../auth.service';

const resolveAuthErrorMessage = (error: unknown) => {
  if (typeof error === 'object' && error !== null && 'code' in error && error.code === 'auth/network-request-failed') {
    return '網路連線不穩定，請確認網路後重新開啟訂貨系統。';
  }

  return '登入驗證失敗，請重新開啟訂貨系統；若問題持續發生，請聯絡管理員。';
};

export const AuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const liffService = inject(LiffService);
  const authService = inject(AuthService);

  // 取得網址
  const url = new URL(window.location.href);
  const baseUrl = url.origin + url.pathname;
  try {
    const liffState = route.queryParams['liff.state'] || '';
    const params = liffState.split('?');
    await liffService.initLiff(environment.line.liffId, environment.site);

    let redirectUri = '';
    if (liffState) {
      if (params[1]) {
        const originalParams = new URLSearchParams(params[1]);
        const map: { [key: string]: string } = {};
        originalParams.forEach(function (value, key) {
          map[key] = value;
        });
        // 會是 ba
        redirectUri = baseUrl + params[0] + '?' + originalParams.toString();
      } else {
        redirectUri = baseUrl + params[0];
      }
    } else {
      redirectUri = window.location.href;
    }

    if (!liffService.isLoggedIn()) {
      liffService.login(redirectUri);
      return false;
    }

    if (liffService.profile.userId === '') {
      await liffService.close();
      return false;
    }

    const decodedIDToken = liffService.liff.getDecodedIDToken();
    // 檢查 idToken 是否有效，如果失效則需要重新登入
    const exp = decodedIDToken!.exp! * 1000; // Token 的過期時間 (毫秒)
    const now = Date.now();

    if (exp < now) {
      liffService.logout();
      liffService.login(redirectUri); // 如果 Token 過期，重新登入
      return false;
    }

    const idToken = liffService.liff.getIDToken() || '';
    // 先完成 LINE/Firebase 登入，後續 orders access guard 才能拿 customToken 打 AWS API。
    await authService.loginLine(environment.site, idToken);

    return true;
  } catch (error: unknown) {
    console.error('Auth Guard failed:', error);
    alert(resolveAuthErrorMessage(error));

    return false;
  }
};
